import React, { useContext, useState } from 'react';
import { layoutContext } from '../CODBGame';
import SingleOption from './SingleOption';
import './Questions.scss';
import { Button } from 'carbon-components-react';
import {
  ArrowRight16,
  DoubleInteger32,
  Help16,
  Restart16,
} from '@carbon/icons-react';
import { Scenario } from '../../data/constants';
import ProgressBar from 'carbon-components-react/lib/components/ProgressBar';
import messages from '../../locales/messages';

interface questionsProps {
  contents: any;
}

const Questions = (questionsProps: questionsProps) => {
  const { contents } = questionsProps;
  const [questionCurrentnumber, setQuestionCurrentnumber] = useState(1);

  const {
    setCurrentScenario,
    selectedItems,
    setSelectedItems,
    selectedOption,
    setWatsonButton,
    setShowPercentageButton,
    setDoublechancedisableclassname,
    refreshclicked,
    setRefreshclicked,
  } = useContext(layoutContext);

  const [iswatsonButtonDisabled, setIsWatsonButtonDisabled] = useState(false);
  const [doubleChanceButton, setDoubleChanceButton] = useState(false);
  const [isDoubleChanceDisabled, setIsDoubleChanceDisabled] = useState(false);
  const [isGray, setIsGray] = useState(false);
  const [isGrayChanceBtn, setIsGrayChanceBtn] = useState(false);
  const selectedItemsArray = Object.values(selectedItems);
  const lengthOfArray = selectedItemsArray.length;
  const maxLength = 10;
  const percentage = (lengthOfArray / maxLength) * 100;

  const questionSet1 = [
    'q1',
    'q2',
    'q3',
    'q4',
    'q5',
    'q6',
    'q7',
    'q8',
    'q9',
    'q10',
    'q11',
    'q12',
    'q13',
    'q14',
    'q15',
    'q16',
    'q17',
    'q18',
    'q19',
    'q20',
    'q21',
  ];

  const currentShuffleArray = shuffleArray(questionSet1);
  let firstId = questionsProps.contents[0].shuffleArray[0];
  if (refreshclicked) {
    firstId = currentShuffleArray[0];
  }
  const [questionId, setQuestionId] = useState(firstId);
  const [watsonCount, setWatsonCount] = useState(0);
  const [doubleCount, setDoubleCount] = useState(0);

  const handleWatsonClick = () => {
    setWatsonButton(true);
    setIsWatsonButtonDisabled(true);
    setShowPercentageButton(true);
    setIsGray(true);
    setIsDoubleChanceDisabled(true);
    setIsGrayChanceBtn(true);
    setWatsonCount(1);
  };

  const handleDoubleChanceClick = () => {
    setDoubleChanceButton(true);
    setIsDoubleChanceDisabled(true);
    setIsGrayChanceBtn(true);
    setIsGray(true);
    setIsWatsonButtonDisabled(true);
    setDoublechancedisableclassname('disappearedclass');
    setDoubleCount(1);
  };

  const handleReset = () => {
    setCurrentScenario(Scenario.introduction);
    setSelectedItems({});
    setWatsonButton(false);
    setIsGray(false);
    setIsGrayChanceBtn(false);
    setDoubleChanceButton(false);
    setDoublechancedisableclassname('');
    setIsDoubleChanceDisabled(false);
    setRefreshclicked(true);
    setWatsonCount(0);
    setDoubleCount(0);
  };

  const handleNext = (qId: string) => {
    if (questionCurrentnumber >= 10) {
      return (
        setCurrentScenario(Scenario.results),
        setSelectedItems({
          ...selectedItems,
          [questionId]: {
            optionId: selectedOption.optionId,
            correctAnswer: selectedOption.correctAnswer,
          },
        })
      );
    } else {
      const nowid = questionCurrentnumber + 1;
      setQuestionCurrentnumber(nowid);
      setDoublechancedisableclassname('appearedclass');
      return (
        setQuestionId(qId),
        setSelectedItems({
          ...selectedItems,
          [questionId]: {
            optionId: selectedOption.optionId,
            correctAnswer: selectedOption.correctAnswer,
          },
        }),
        setIsDoubleChanceDisabled(false),
        setIsWatsonButtonDisabled(false),
        setWatsonButton(false),
        setIsGrayChanceBtn(false),
        setIsGray(false)
      );
    }
  };

  return (
    <div
      className="codb-game__question"
      style={{
        backgroundImage: `url("${process.env.PUBLIC_ASSETS_URL}/codb-game/images/background-2-codb-game.png")`,
      }}
    >
      {contents.map((question: any, i: number) => {
        if (question.id === questionId) {
          return (
            <>
              <div key={questionId + '-progress'}>
                <div className="bx--col-lg-16 codb-game__progressBar">
                  <ProgressBar
                    label={question.category}
                    value={percentage}
                    max={100}
                  />
                </div>
              </div>
              <div className="codb-game" key={questionId}>
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 codb-game__question-wrapper">
                  <p className="codb-game__question-indicator">
                    {questionCurrentnumber + ' . '} {question.title}
                  </p>
                  <div className="bx--col-lg-16 bx--col-md-6 bx--col-sm-4 codb-game__answer-wrapper">
                    <SingleOption
                      options={question.options}
                      helpLabel={messages.helpLabel.defaultMessage}
                    />
                  </div>
                </div>
                <div className="codb-game__button">
                  <Button
                    kind="tertiary"
                    className="codb-game__question-cta-previous"
                    onClick={handleReset}
                  >
                    <Restart16 className="codb-game__question-cta-previous-restart" />
                  </Button>
                  <Button
                    kind="tertiary"
                    disabled={
                      questionCurrentnumber >= contents.length ||
                      selectedOption.optionId.length === 0 ||
                      selectedOption.nextStep === questionId
                    }
                    className="codb-game__question-cta-next"
                    onClick={() => handleNext(selectedOption.nextStep)}
                  >
                    <ArrowRight16 />
                    {/* tecnicamente esse icon aqui a gente poderia adicionar no button como renderIcon 
                    ao invés de passar assim, o proprio componente ajusta. Mas como fizemos assim, foi meio role tentar desativar o CSS aí podemos deixar assi */}
                  </Button>
                </div>

                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 codb-game__help">
                  <p className="codb-game__help-lifeLine">
                    {messages.helpGuideline.defaultMessage}
                  </p>
                  <div className="codb-game__help-button">
                    <Button
                      kind="tertiary"
                      className="codb-game__question-cta-previous codb-game__help-button-container "
                      onClick={handleWatsonClick}
                      disabled={iswatsonButtonDisabled || watsonCount > 0}
                    >
                      <p className="codb-game__help-button-name">
                        {messages.buttonHelp1.defaultMessage}
                      </p>
                      <Help16
                        className={
                          isGray || watsonCount > 0
                            ? 'codb-game__help-button-isGray'
                            : 'codb-game__help-button-watsonIcon'
                        }
                      />
                    </Button>
                    <Button
                      kind="tertiary"
                      className="codb-game__question-cta-previous codb-game__help-button-container"
                      onClick={handleDoubleChanceClick}
                      disabled={isDoubleChanceDisabled || doubleCount > 0}
                    >
                      <p className="codb-game__help-button-name">
                        {messages.buttonHelp2.defaultMessage}
                      </p>

                      <DoubleInteger32
                        className={
                          isGrayChanceBtn || doubleCount > 0
                            ? 'codb-game__help-button-isDoubleChanceGray'
                            : 'codb-game__help-button-doubleChance'
                        }
                      />
                      {/* eu removi o icon de dentro do paragrafo pq fica melhor de estilizar as duas coisas separadamente (especialmente no mobile) */}
                    </Button>
                  </div>
                </div>
              </div>
            </>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

const shuffleArray = (array: string[]) => {
  const sortedArr = structuredClone(array);
  for (let i = sortedArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [sortedArr[i], sortedArr[j]] = [sortedArr[j], sortedArr[i]];
  }
  return sortedArr;
};

export default Questions;
